export default __webpack_public_path__ + "static/media/002-youtube.b42647fb.svg";